<script setup lang="ts">
/* eslint-disable max-len */
interface IconLockProps {
  fill?: string;
}
const props = withDefaults(defineProps<IconLockProps>(), { fill: "currentColor" });
</script>

<template>
  <svg width="6" height="8" viewBox="0 0 6 8" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.27 3.255h-.216l-.001-1.094C5.053.969 4.099-.001 2.927 0 1.756 0 .803.97.804 2.163l.001 1.094H.73A.736.736 0 0 0 0 4v3.258C0 7.668.328 8 .73 8l4.541-.003c.403 0 .73-.332.729-.742V3.996a.736.736 0 0 0-.73-.74zm-3.682.002-.002-1.094c0-.753.602-1.366 1.341-1.367.74 0 1.342.613 1.342 1.365l.002 1.094-2.683.002z"
      :fill="props.fill"
      fill-rule="evenodd"
    />
  </svg>
</template>
